
import { removeToken } from '@/Utils/authServiceCookie';
import router from '@/router';
import store from '@/store';
import { defineComponent } from 'vue';

const pageTitles: Record<string, string> = {
    Services: 'داشبورد مدیریت',
    Users: 'مدیریت کاربران',
    Reports: 'گزارشات',
    'platform-logs': 'لاگ سیستم',
    PlatformLogs: 'لاگ سیستم',
    Transactions: 'تراکنش‌ها',
    ManualCharges: 'شارژهای دستی',
    Gateways: 'مدیریت درگاه‌ها',
    Exchange: 'صرافی',
    Settings: 'تنظیمات سامانه'
};

export default defineComponent({
    name: 'NavbarComponent',
    computed: {
        pageTitle(): string {
            return pageTitles[String(this.$route.name)] || 'پنل مدیریت';
        },
        sidebarOpen(): boolean {
            return store.getters['app/getSidebarStatus'];
        }
    },
    methods: {
        toggleSidebar(): void {
            store.dispatch('app/toggleSidebarStatus');
        },
        handleLogout(): void {
            removeToken();
            router.push({ name: 'Authentication' });
        }
    }
});
